// components/LazyImage.tsx
import React from 'react';

const LazyImage: React.FC<any> = (props) => {
  return <img {...props} loading="lazy"/>;
};

export default LazyImage;
